import { createContext, useCallback, useContext, useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { STRINGS } from "./strings";

export const ROUTES = {
  home: { en: "/", es: "/es" },
  work: { en: "/work", es: "/es/trabajo" },
  services: { en: "/services", es: "/es/precios" },
  studio: { en: "/studio", es: "/es/estudio" },
  contact: { en: "/contact", es: "/es/contacto" },
  sheet: { en: "/pricing-sheet", es: "/es/hoja-de-precios" },
};

const STORE_KEY = "starvynt-lang";
const LangContext = createContext(null);

export const routeKeyFor = (pathname) => {
  const clean = pathname.replace(/\/+$/, "") || "/";
  return Object.keys(ROUTES).find((k) => ROUTES[k].en === clean || ROUTES[k].es === clean) || "home";
};

export function LangProvider({ children }) {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  const lang = pathname === "/es" || pathname.startsWith("/es/") ? "es" : "en";

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  // Remember choice: a returning Spanish visitor landing on "/" goes to "/es".
  useEffect(() => {
    if (pathname === "/" && localStorage.getItem(STORE_KEY) === "es") navigate("/es", { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const path = useCallback((key) => ROUTES[key][lang], [lang]);
  const switchLang = useCallback(
    (to) => {
      localStorage.setItem(STORE_KEY, to);
      navigate(ROUTES[routeKeyFor(pathname)][to] + search);
    },
    [navigate, pathname, search]
  );

  const value = useMemo(() => ({ lang, t: STRINGS[lang], path, switchLang }), [lang, path, switchLang]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
